module.exports = __webpack_public_path__ + "img/mobile-logo.e2bf120e.svg";